import { render, staticRenderFns } from "./BProcessoFilterBar.vue?vue&type=template&id=0073244d"
import script from "./BProcessoFilterBar.vue?vue&type=script&lang=js"
export * from "./BProcessoFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports